import { isToolStartAllowed } from '../config/toolMatrix'
import type { CommandDeckPreviewBundle, ToolCardModel } from '../contracts/types'
import { deriveSurfaceConstellation } from './missionControlModel'

interface Props {
  bundle: CommandDeckPreviewBundle
  compact?: boolean
  onToolAction?: (tool: ToolCardModel) => void
}

export function CommandDeckSurfaceConstellation({ bundle, compact = false, onToolAction }: Props) {
  const activeSurface =
    bundle.personalization.surface.surfaceId !== 'none'
      ? bundle.personalization.surface.surfaceId
      : bundle.bestNextMove.primary.suggestedSurface
  const nodes = deriveSurfaceConstellation(bundle.tools, activeSurface)
  const tools = bundle.tools.filter(
    (t) => t.toolId !== 'request_access' && t.toolId !== 'book_demo'
  )

  return (
    <section
      className={`cd-mc-constellation command-deck-glass${compact ? ' cd-mc-constellation--compact' : ''}`}
      aria-labelledby="cd-mc-constellation-heading"
    >
      <h2 id="cd-mc-constellation-heading">{compact ? 'Surfaces' : 'Surface Constellation'}</h2>
      <div className="cd-mc-constellation__map" role="list">
        {nodes.map((node) => {
          const tool = tools.find((t) =>
            node.id === 'guided_studio'
              ? t.toolId === 'guided_studio'
              : node.id === 'scapes'
                ? t.toolId === 'scapes_worlds'
                : node.id === 'xr'
                  ? t.toolId === 'xr_worlds'
                  : t.toolId === node.id
          )
          const canStart = tool ? isToolStartAllowed(tool.availability) : false
          return (
            <button
              key={node.id}
              type="button"
              role="listitem"
              className={`cd-mc-constellation__node cd-mc-constellation__node--${node.state}`}
              disabled={!canStart}
              onClick={() => tool && onToolAction?.(tool)}
            >
              <span className="cd-mc-constellation__label">{node.label}</span>
              <span className="cd-mc-constellation__state">{node.state}</span>
            </button>
          )
        })}
      </div>
    </section>
  )
}
